<template>
  <div ref="root" v-bind="$attrs">
    <slot>
      <SloLoader :loading="true" size="xl" />
    </slot>
  </div>
</template>

<script>
import t from '../main/i18n';
import SloLoader from '../../lib/components/SloLoader.vue';

export default {
  name: 'SloInfiniteLoader',
  components: {
    SloLoader
  },
  mounted() {
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(([entry]) => {
        this.onVisibilityChange(entry.isIntersecting, entry);
      });
      this.io.observe(this.$refs.root, {
        rootMargin: '100px',
        threshold: [0, 1]
      });

      setTimeout(() => {
        const footer = document.querySelector('.site-footer');
        if (footer && this.io) {
          this.io.observe(footer, {
            rootMargin: '0',
            threshold: [0, 1]
          });
        }
      }, 100);
    }
  },
  beforeDestroy() {
    this.io.disconnect();
    this.io = null;
  },
  data() {
    return {io: null};
  },
  props: {
    disabled: {default: false}
  },
  filters: {
    t
  },
  methods: {
    onVisibilityChange(isVisible) {
      if (isVisible && !this.disabled) this.$emit('refineNext');
    }
  }
};
</script>
